(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dev-modal"] && !Shopify.designMode) return;
  try {
    // One delegated listener for every dialog on the page, bound once. Re-running
  // this file (Shopify concatenates each component's javascript block, not per
  // instance) would otherwise stack duplicate handlers on section re-render.
  if (!window.__devModalBound) {
    window.__devModalBound = true;

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-dev-modal-open]');
      if (opener) {
        const dialog = document.getElementById(opener.getAttribute('data-dev-modal-open'));
        if (dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          dialog.showModal();
        }
        return;
      }

      if (event.target.closest('[data-dev-modal-close]')) {
        const dialog = event.target.closest('dialog');
        if (dialog) dialog.close();
        return;
      }

      // Clicking the backdrop: the event target is the <dialog> itself, because
      // the panel covers the whole dialog box. Compare against the panel's rect
      // so a click beside it closes and a click inside it does not.
      if (event.target.tagName === 'DIALOG') {
        const panel = event.target.querySelector('.dev-modal__panel');
        if (!panel) return;
        const r = panel.getBoundingClientRect();
        const outside =
          event.clientX < r.left || event.clientX > r.right ||
          event.clientY < r.top || event.clientY > r.bottom;
        if (outside) event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
